const AgentSale = {
  MissingInformation: "AgentSale.MissingInformation",
  ObjectNumber: "AgentSale.ObjectNumber",
  MissingInformationTitle: "AgentSale.MissingInformationTitle",
  MissingInformationListHeader: "AgentSale.MissingInformationListHeader",
  MissingInformationListDescription: "AgentSale.MissingInformationListDescription",
  SimpleTodoAddedDate: "AgentSale.SimpleTodoAddedDate",
  SimpleTodoContent: "AgentSale.SimpleTodoContent",
  MissingInformationTodoDescription: "AgentSale.MissingInformationTodoDescription",
  MissingInformationBulletTitle: "AgentSale.MissingInformationBulletTitle",
  }
export default AgentSale;